import * as React from 'react';
import type { SVGProps } from 'react';
const IconBookmark = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    data-xds="IconBookmark"
    role="presentation"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5 3h14v18l-7-4.372L5 21zm2 2v12.393l5-3.123 5 3.123V5z"
      clipRule="evenodd"
    />
  </svg>
);
export default IconBookmark;
